import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import { MediaPlansResponseSchema } from '../shared/schemas.js';

export type { MediaPlanType } from '../shared/schemas.js';
export const mediaPlans = defaultClient.query({
  url: 'authentication/v1/media_plans/' as const,
  method: 'GET',
  querySchema: z.object({
    search: z.string().optional(),
  }),
  responseSchema: MediaPlansResponseSchema,
  processResponse(data) {
    return data;
  },
});
